module.exports = __webpack_public_path__ + "img/ico-6-active.01daa310.svg";